<template>
  <div class="login-container">
    <el-form
      :model="form"
      :rules="rules"
      ref="loginForm"
      class="login-form"
      @submit.native.prevent="handleLogin"
    >
      <div class="header">
        <img alt="logo" class="logo" :src="logo || logoImage" />
        <p class="desc">{{ title || '开源物联可视化' }}</p>
      </div>

      <el-form-item prop="username">
        <el-input
          v-model="form.username"
          placeholder="用户名"
          prefix-icon="el-icon-user"
          clearable
        />
      </el-form-item>

      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          :type="showPassword ? 'text' : 'password'"
          placeholder="密码"
          prefix-icon="el-icon-lock"
          show-password
        />
      </el-form-item>

      <el-form-item prop="verifyCode" class="captcha-group">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-input v-model="form.verifyCode" placeholder="验证码" />
          </el-col>
          <el-col :span="10">
            <img
              :src="captchaUrl"
              @click="loadCaptcha"
              alt="验证码"
              class="captcha-img"
            />
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item class="checkbox-group">
        <el-checkbox v-model="form.remember"></el-checkbox>
        记住我
      </el-form-item>

      <el-form-item>
        <el-button type="primary" native-type="submit" style="width: 100%">
          登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { login, get_captch } from "@/api/auth";

export default {
  name: "Right",
  props: {
    logo: String,
    title: String,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        verifyCode: "",
        verifyKey: "",
        remember: false,
        expires: 31536000000,
      },
      showPassword: false,
      captchaUrl: "",
      logoImage: require("@/assets/logo.png"),
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        verifyCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
    async loadCaptcha() {
      try {
        const res = await get_captch();
        const { key, base64 } = res.data.result;
        this.form.verifyKey = key;
        this.captchaUrl = base64;
      } catch (error) {
        this.$message.error("验证码加载失败");
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return;
        try {
          const res = await login(this.form);
          if (res.data.status === 200) {
            const result = res.data.result;
            this.$message.success("登录成功");
            localStorage.setItem("x-access-token", result.token);
            const redirect = this.$route.query.redirect;
            this.$router.push(typeof redirect === "string" && redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : "/");
          } else {
            this.$message.error(res.data.message || "登录失败");
            this.loadCaptcha();
          }
        } catch (e) {
          this.$message.error(e?.data?.message || "登录请求失败");
          this.loadCaptcha();
        }
      });
    },
  },
  mounted() {
    this.loadCaptcha();
  },
};
</script>

<style scoped lang="scss">
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #fff;
  box-sizing: border-box;
  padding: 16px;
  min-width: 0;
}

.login-form {
  background: white;
  padding: 30px 25px;
  border-radius: 8px;
  width: 370px;
  max-width: 100%;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.header {
  text-align: center;
  margin-bottom: 24px;
}

.logo {
  display: block;
  height: 44px;
  margin: 0 auto;
}

.desc {
  margin-top: 16px;
  margin-bottom: 24px;
  color: #333;
  font-weight: 600;
  font-size: 20px;
}

.captcha-img {
  height: 37px;
  width: 100%;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.checkbox-group {
  font-size: 14px;
  color: #666;
}

/* 自定义默认状态 */
::v-deep(.el-input__inner) {
  background-color: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
}

/* 只在未勾选状态下保持白底 */
::v-deep(.el-checkbox__inner) {
  background-color: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
}

/* 设置勾选状态下背景为蓝色，对勾为白色 */
::v-deep(.el-checkbox.is-checked .el-checkbox__inner) {
  background-color: #409EFF !important; /* Element UI 主色调 */
  border-color: #409EFF !important;
}

::v-deep(.el-checkbox__inner::after) {
  border-color: #fff !important; /* 勾选的 √ 颜色 */
}
</style>

